import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Buttons/Button';

const Pager = ({ loading, showPrevButton, showNextButton, onPrevClick, onNextClick }) => {
  return (
    <div className="pager d-flex">
      {showPrevButton &&
        <Button onClick={onPrevClick} classes="btn--tertiary" disabled={loading} spinColor="black">Prev</Button>
      }

      {showNextButton &&
        <Button onClick={onNextClick} classes="btn--tertiary m-l-auto" disabled={loading} spinColor="black">Next</Button>
      }
    </div>
  );
};

Pager.propTypes = {
  loading: PropTypes.bool,
  showPrevButton: PropTypes.bool,
  showNextButton: PropTypes.bool,
  onPrevClick: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired,
};

export default Pager;



// WEBPACK FOOTER //
// ./library/app/components/Global/Pager/Pager.js